import { BASE_BE_URL } from "../../../lib/sessionClient";

export const JOBCARD_REPORT_OPTION =
  BASE_BE_URL + "/factory/setup/report/checkpoints";
export const jobcardReport = (startDate, endDate, checkpointName) =>
  `${BASE_BE_URL}/factory/report/details/${startDate}/${endDate}/${checkpointName}`;
